import React, {useContext, useEffect, useState} from "react";
import axiosInstance from "../../configurations/axiosInstance/AxiosInstance";
import {toastClick} from "../../composants/toast/CustomToast";
import {Button, Form, Input, Select} from "antd";
import Loader from "../../composants/loader/Loader";
import { LoadingContext } from "../../composants/loadingContext";

function Register() {
  const {loading, setLoading} = useContext(LoadingContext);
  const [form] = Form.useForm();
  const [departements, setDepartements] = useState([]);
  const [regions, setRegions] = useState([]);
  const [communes, setCommunes] = useState([]);

  const submitRegisterForm = (event) => {
    const { departement, region, commune, numero_telephone,  ...dat } = event;
    const utilisateur = dat;
    utilisateur.communes = {
      "id":commune
    };
    utilisateur.phoneNumbers = [numero_telephone];
    utilisateur.numero_telephone = numero_telephone;
    for (let com of communes){
      if(communes[com].id === commune)
        utilisateur.location = communes[com].name;
    }
    setLoading(true);
    axiosInstance().post('public/user/register', utilisateur)
      .then(function (response) {
        toastClick("Inscription réussie !", "Bienvenue dans la communauté YouthFP");
        form.resetFields();
        setLoading(false);
        window.open("https://client.youthfp.cm/login", "_blank");
        setTimeout(() => {
          window.location.href='/';
        }, 2000);
      })
      .catch(function (error) {
        setLoading(false);
        const errorMsg = error.response?.data?.error || "Une erreur est survenue";
        toastClick("Échec de l'inscription", errorMsg);
        console.error('Erreur inscription:', error);
      });
  };

  const regionOnChange = (event) => {
    form.setFieldsValue({ departement: undefined, commune: undefined });
    fetchDepartement(event);
  };

  const departementOnChange = (event) => {
    form.setFieldsValue({ commune: undefined });
    fetchCommune(event);
  };

  const fetchRegion = () => {
    axiosInstance().get('public/locality/list/reg')
      .then(response => {
        setRegions(response.data);
        setDepartements([]);
        setCommunes([]);
      })
      .catch(error => {
        console.error('Erreur chargement régions:', error);
        toastClick("Erreur", "Impossible de charger les régions");
      });
  };

  const fetchDepartement = (regionId) => {
    setDepartements([]);
    setCommunes([]);
    axiosInstance().get('public/locality/list/dep/' + regionId)
      .then(response => {
        setDepartements(response.data);
        setCommunes([]);
      })
      .catch(error => {
        console.error('Erreur chargement départements:', error);
      });
  };

  const fetchCommune = (departementId) => {
    axiosInstance().get('public/locality/list/com/' + departementId)
      .then(response => {
        setCommunes(response.data);
      })
      .catch(error => {
        console.error('Erreur chargement communes:', error);
      });
  };

  useEffect(() => {
    document.title = "YouthFP | Créer un compte";
    fetchRegion();
    setLoading(false);
  }, [setLoading]);

  return (
    <>
      {loading && <Loader />}
      
      {/* Hero Banner */}
      <section className="relative pt-20 pb-12 bg-gradient-to-br from-purple-600 via-pink-500 to-red-500 overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-10"></div>
        <div className="absolute top-0 left-0 w-full h-full">
          <div className="absolute top-10 right-10 w-96 h-96 bg-white rounded-full opacity-5 blur-3xl"></div>
          <div className="absolute bottom-10 left-10 w-72 h-72 bg-purple-300 rounded-full opacity-5 blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center text-white">
            <div className="inline-block mb-6 px-6 py-2 bg-white bg-opacity-20 rounded-full backdrop-blur-sm">
              <span className="text-sm font-medium">✨<b className=" text-black"> Rejoignez la Communauté</b></span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
              Créez Votre Compte YouthFP
            </h1>
            <p className="text-lg md:text-xl opacity-95 max-w-2xl mx-auto">
              Accédez à nos services de santé sexuelle et reproductive. 
              Prenez rendez-vous avec des spécialistes qualifiés.
            </p>
          </div>
        </div>
      </section>

      {/* Main Registration Form */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            
            {/* Sponsor/Financeur Section */}
            <div className="mb-12 bg-white rounded-2xl shadow-md p-6 border-l-4 border-purple-500">
              <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="flex-1 text-center md:text-left">
                  <p className="text-sm text-gray-600 mb-2">Projet financé par</p>
                  <h3 className="text-xl font-semibold text-gray-800">Notre Partenaire Stratégique</h3>
                </div>
                <div className="flex-shrink-0">
                  <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                    <img 
                      src="/images/pngegg.png" 
                      alt="Logo du financeur" 
                      className="h-20 md:h-24 w-auto object-contain"
                    />
                  </div>
                </div>
                <div className="flex-1 text-center md:text-right">
                  <p className="text-sm text-gray-600 italic">
                    "Ensemble pour la santé des jeunes"
                  </p>
                </div>
              </div>
            </div>

            {/* Form Card */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
              
              {/* Form Header */}
              <div className="bg-gradient-to-r from-purple-600 to-pink-600 px-8 py-6 text-white">
                <h2 className="text-2xl md:text-3xl font-bold mb-2">Formulaire d'Inscription</h2>
                <p className="text-purple-100">Remplissez vos informations pour créer votre compte</p>
              </div>

              {/* Form Content */}
              <div className="px-8 py-10">
                <Form 
                  form={form} 
                  onFinish={submitRegisterForm} 
                  layout="vertical"
                  requiredMark="optional"
                  className="space-y-6"
                >
                  
                  {/* Section 1: Informations Personnelles */}
                  <div className="space-y-6">
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                        <svg className="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                      </div>
                      <h3 className="text-xl font-semibold text-gray-800">Informations Personnelles</h3>
                    </div>

                    <div className="grid md:grid-cols-2 gap-6">
                      <Form.Item 
                        label={<span className="font-medium text-gray-700">Nom</span>}
                        name="nom" 
                        rules={[
                          { required: true, message: 'Veuillez entrer votre nom' }, 
                          { type: "string", message: "Veuillez entrer votre nom !" }
                        ]} 
                        hasFeedback
                      >
                        <Input 
                          placeholder="Votre nom de famille" 
                          className="rounded-lg border-gray-300 focus:border-purple-500 focus:ring-purple-500" 
                          size="large"
                        />
                      </Form.Item>

                      <Form.Item
                        label={<span className="font-medium text-gray-700">Prénom</span>}
                        name="prenom"
                        rules={[
                          { required: true, message: 'Veuillez entrer votre prénom' },
                          { type: "string", message: "Veuillez entrer votre prénom !" }
                        ]}
                        hasFeedback
                      >
                        <Input 
                          placeholder="Votre prénom" 
                          className="rounded-lg border-gray-300 focus:border-purple-500 focus:ring-purple-500" 
                          size="large"
                        />
                      </Form.Item>
                    </div>

                    <div className="grid md:grid-cols-2 gap-6">
                      <Form.Item
                        label={<span className="font-medium text-gray-700">E-mail (Optionnel)</span>}
                        name="email"
                        rules={[
                          { type: 'email', message: 'Email invalide' }
                        ]}
                      >
                        <Input 
                          placeholder="exemple@email.com" 
                          className="rounded-lg border-gray-300 focus:border-purple-500 focus:ring-purple-500" 
                          size="large"
                          prefix={
                            <svg className="w-4 h-4 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                          }
                        />
                      </Form.Item>

                      <Form.Item
                        label={<span className="font-medium text-gray-700">Numéro de téléphone</span>}
                        name="numero_telephone"
                        rules={[
                          { required: true, message: 'Veuillez entrer votre numéro' },
                          { type: "string", message: "Entrer le numéro de téléphone!" },
                          { len: 9, message: "Le numéro doit contenir 9 chiffres !" },
                          { pattern: /^6[0-9]{8}$/, message: "Le numéro doit commencer par 6 (ex: 670123456)" }
                        ]}
                        hasFeedback
                      >
                        <Input 
                          placeholder="6XX XXX XXX" 
                          className="rounded-lg border-gray-300 focus:border-purple-500 focus:ring-purple-500" 
                          size="large"
                          prefix={
                            <svg className="w-4 h-4 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                            </svg>
                          }
                        />
                      </Form.Item>
                    </div>

                    <Form.Item
                      label={<span className="font-medium text-gray-700">Sexe</span>}
                      name="sexe"
                      rules={[
                        { required: true, message: "Veuillez sélectionner votre sexe" }
                      ]}
                      hasFeedback
                    >
                      <Select 
                        placeholder="Sélectionnez votre sexe" 
                        className="rounded-lg" 
                        size="large"
                      >
                        <Select.Option value="HOMME">
                          <span className="flex items-center">
                            <span className="mr-2">👨</span> Homme
                          </span>
                        </Select.Option>
                        <Select.Option value="FEMME">
                          <span className="flex items-center">
                            <span className="mr-2">👩</span> Femme
                          </span>
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </div>

                  {/* Divider */}
                  <div className="border-t border-gray-200 my-8"></div>

                  {/* Section 2: Localisation */}
                  <div className="space-y-6">
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center">
                        <svg className="w-5 h-5 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                      </div>
                      <h3 className="text-xl font-semibold text-gray-800">Localisation</h3>
                    </div>

                    <Form.Item
                      label={<span className="font-medium text-gray-700">Région</span>}
                      name="region"
                      rules={[
                        { required: true, message: 'Veuillez sélectionner votre région' }
                      ]}
                      hasFeedback
                    >
                      <Select 
                        onSelect={regionOnChange} 
                        placeholder="Sélectionnez une région"
                        size="large"
                        showSearch
                        optionFilterProp="children"
                      >
                        {regions.map((region) => (
                          <Select.Option key={region.id} value={region.id}>
                            {region.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label={<span className="font-medium text-gray-700">Département</span>}
                      name="departement"
                      rules={[
                        { required: true, message: 'Veuillez sélectionner un département' }
                      ]}
                      hasFeedback
                    >
                      <Select 
                        onSelect={departementOnChange} 
                        placeholder="Sélectionnez un département"
                        size="large"
                        showSearch
                        optionFilterProp="children"
                        disabled={departements.length === 0}
                      >
                        {departements.map((departement) => (
                          <Select.Option key={departement.id} value={departement.id}>
                            {departement.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label={<span className="font-medium text-gray-700">Commune</span>}
                      name="commune"
                      rules={[
                        { required: true, message: 'Veuillez sélectionner une commune' }
                      ]}
                      hasFeedback
                    >
                      <Select 
                        placeholder="Sélectionnez une commune"
                        size="large"
                        showSearch
                        optionFilterProp="children"
                        disabled={communes.length === 0}
                      >
                        {communes.map((commune) => (
                          <Select.Option key={commune.id} value={commune.id}>
                            {commune.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>

                  {/* Divider */}
                  <div className="border-t border-gray-200 my-8"></div>

                  {/* Section 3: Sécurité */}
                  <div className="space-y-6">
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                        <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                      </div>
                      <h3 className="text-xl font-semibold text-gray-800">Mot de Passe</h3>
                    </div>

                    <Form.Item
                      label={<span className="font-medium text-gray-700">Mot de passe</span>}
                      name="pwd"
                      rules={[
                        { required: true, message: 'Veuillez saisir un mot de passe' },
                        { min: 8, message: 'Le mot de passe doit contenir au moins 8 caractères' }
                      ]}
                      hasFeedback
                    >
                      <Input.Password 
                        placeholder="••••••••" 
                        className="rounded-lg" 
                        size="large"
                      />
                    </Form.Item>

                    <Form.Item
                      label={<span className="font-medium text-gray-700">Confirmer le mot de passe</span>}
                      name="confirm"
                      dependencies={['pwd']}
                      rules={[
                        { required: true, message: 'Veuillez confirmer votre mot de passe' },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('pwd') === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error('Les mots de passe ne correspondent pas !'));
                          },
                        }),
                      ]}
                      hasFeedback
                    >
                      <Input.Password 
                        placeholder="••••••••" 
                        className="rounded-lg" 
                        size="large"
                      />
                    </Form.Item>

                    {/* Privacy Notice */}
                    <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg">
                      <div className="flex">
                        <svg className="w-5 h-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        <div>
                          <p className="text-sm text-blue-700">
                            <strong className="font-semibold">Confidentialité :</strong> Vos données personnelles sont sécurisées et ne seront utilisées que pour la gestion de votre compte et l'accès à nos services de santé.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="pt-6">
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={loading}
                      size="large"
                      className="w-full h-14 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 border-0 rounded-xl text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                    >
                      {loading ? (
                        <span className="flex items-center justify-center">
                          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          Création en cours...
                        </span>
                      ) : (
                        <span className="flex items-center justify-center">
                          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          Créer Mon Compte
                        </span>
                      )}
                    </Button>

                    <p className="text-center text-sm text-gray-600 mt-6">
                      Vous avez déjà un compte ?{' '}
                      <a href="https://client.youthfp.cm/login" className="text-purple-600 hover:text-purple-700 font-semibold hover:underline">
                        Connectez-vous ici
                      </a>
                    </p>
                  </div>
                </Form>
              </div>
            </div>

            {/* Benefits Section */}
            <div className="mt-12 grid md:grid-cols-3 gap-6">
              <div className="bg-white rounded-xl p-6 shadow-md border-t-4 border-purple-500 hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="font-semibold text-lg mb-2">Consultation Gratuite</h3>
                <p className="text-gray-600 text-sm">Accédez à des consultations gratuites avec nos spécialistes</p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md border-t-4 border-pink-500 hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="font-semibold text-lg mb-2">Rendez-vous Rapide</h3>
                <p className="text-gray-600 text-sm">Prenez rendez-vous facilement en ligne, 24h/24</p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md border-t-4 border-red-500 hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <h3 className="font-semibold text-lg mb-2">Suivi Personnalisé</h3>
                <p className="text-gray-600 text-sm">Bénéficiez d'un suivi personnalisé adapté à vos besoins</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Register;